import Vue from "vue"
import VueRouter from 'vue-router'
//使用插件
Vue.use(VueRouter)
const Home = () => import('@/pages/home')
const Aboutus = () => import('@/pages/aboutus')
const ActivitySubmit = () => import('@/pages/activitySubmit')
const Dynamic = () => import('@/pages/dynamic/index')
const Activity = () => import('@/pages/activity/index')
const ActivityDetail = () => import('@/pages/activity/activityDetail')
const DynamicDetail = () => import('@/pages/dynamic/dynamicDetail')
const Login = () => import('@/pages/admin/login')
const Settle = () => import('@/pages/settle')
//以下为后台页面
const Admin = () => import('@/pages/admin')
const AdminIndex = () => import('@/pages/admin/home')
const AdminSelection = () => import('@/pages/admin/selection')
const StudentHot = () => import('@/pages/admin/home/studentHot')
const SchoolHot = () => import('@/pages/admin/home/schoolHot')
const StudentCollect = () => import('@/pages/admin/home/studentCollect')
//活动相关
const ActivityIndex = () => import('@/pages/admin/activityManager')
const AddActivity = () => import('@/pages/admin/activityManager/addActivity')
const ActivityList = () => import('@/pages/admin/activityManager/activityList')
const ActivityVote = () => import('@/pages/admin/activityManager/activityVote')
const AdminActDetail = () => import('@/pages/admin/activityManager/detail')
const Signature = () => import('@/pages/admin/activityManager/signature')
const FeedList = () => import('@/pages/admin/activityManager/feed')
const CommentList = () => import('@/pages/admin/activityManager/feed/commentList')
const MessageList = () => import('@/pages/admin/activityManager/message')
const TaskList = () => import('@/pages/admin/activityManager/task')
const EnrollList = () => import('@/pages/admin/activityManager/enroll')
const CertificateList = () => import('@/pages/admin/activityManager/certificate')
const CertDetail = () => import('@/pages/admin/activityManager/certificate/detail')
const Contract = () => import('@/pages/admin/activityManager/contract')
const Report = () => import('@/pages/admin/activityManager/report')
const StatisticsArea = () => import('@/pages/admin/activityManager/statisticsArea')
 //投票
const VoteIndex = () => import('@/pages/admin/vote')
const VoteList = () => import('@/pages/admin/vote/voteList')
const VoteLog = () => import('@/pages/admin/vote/voteList/voteLog')
const AddSelection = () => import('@/pages/admin/vote/addSelection')
const VoteDetail = () => import('@/pages/admin/vote/detail')
//配置路由
const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		component: Home,
		meta: {
			title: "圆满假期"
		}
	},
	{
		path: '/aboutus',
		component: Aboutus,
		meta: {
			title: '关于我们'
		}
	},
	{
		path: '/activitySubmit',
		component: ActivitySubmit,
		meta: {
			title: '发起活动'
		}

	},
	{
		path: '/dynamic',
		component: Dynamic,
		meta: {
			title: '所有动态'
		}
	},
	{
		path: '/activity',
		component: Activity,
		meta: {
			title: '已有活动'
		}

	},
	{
		path: '/settle',
		component: Settle,
		meta: {
			title: '入驻'
		}
	},
	{
		path: '/activity/activityDetail/:id',
		component: ActivityDetail
	},
	{
		path: '/dynamic/dynamicDetail/:id',
		component: DynamicDetail
	},
	{
		path: '/admin',
		component: Admin,
		redirect: '/admin/index',
		meta: {
			title: '首页',
			isAdmin: true,
			isLogin: true
		},
		children: [
			{
				path: '/admin/index',
				component: AdminIndex,
				meta: {
					title: '首页',
					isAdmin: true
				}
			},
			{
				path: '/admin/studentHot',
				component: StudentHot,
				meta: {
					title: '学生热力榜',
					isAdmin: true
				}
			},
			{
				path: '/admin/schoolHot',
				component: SchoolHot,
				meta: {
					title: '高校热力榜',
					isAdmin: true
				}
			},
			{
				path: '/admin/studentCollect',
				component: StudentCollect,
				meta: {
					title: '我的收藏',
					isAdmin: true
				}
			},
			{
				path: '/admin/statisticsArea',
				component: StatisticsArea,
				meta: {
					title: '触达区域统计',
					isAdmin: true
				}
			},
			{
				path: '/admin/statisticsArea2',
				component: StatisticsArea,
				meta: {
					title: '触达学校统计',
					isAdmin: true
				}
			},
			{
				path: '/admin/vote',
				component: VoteIndex,
				redirect: '/admin/voteList',
				meta: {
					title: '投票管理',
					isAdmin: true
				},
				children: [
					{
						path: '/admin/voteList',
						component: VoteList,
						meta: {
							title: '投票管理',
							isAdmin: true
						}
					},
					{
						path: '/admin/selection',
						component: AdminSelection,
						meta: {
							title: '添加投票',
							isAdmin: true
						}
					},
					{
						path: '/admin/addSelection',
						component: AddSelection,
						meta: {
							title: '发起投票',
							isAdmin: true
						}
					},
					{
						path: '/admin/voteList/voteLog',
						component: VoteLog,
						meta: {
							title: '投票记录',
							isAdmin: true
						}
					},
					{
						path: '/admin/vote/detail',
						component: VoteDetail,
						meta: {
							title: '投票详情',
							isAdmin: true
						}
					}
				]
			},
			{
				path: '/admin/activityIndex',
				component: ActivityIndex,
				redirect: '/admin/activityList',
				meta: {
					title: '活动管理',
					isAdmin: true
				},
				children: [
					{
						path: '/admin/activityList',
						component: ActivityList,
						meta: {
							title: '活动管理',
							isAdmin: true
						}
					},
					{
						path: '/admin/addActivity',
						component: AddActivity,
						meta: {
							title: '发起活动',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/detail',
						component: AdminActDetail,
						meta: {
							title: '活动详情',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/activityVote',
						component: ActivityVote,
						meta: {
							title: '投票管理',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/signature',
						component: Signature,
						meta: {
							title: '签收',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/feed',
						component: FeedList,
						meta: {
							title: '动态列表',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/commentList',
						component: CommentList,
						meta: {
							title: '评价列表',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/message',
						component: MessageList,
						meta: {
							title: '消息列表',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/task',
						component: TaskList,
						meta: {
							title: '任务列表',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/enroll',
						component: EnrollList,
						meta: {
							title: '报名审核',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/certificate',
						component: CertificateList,
						meta: {
							title: '证书列表',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/certDetail',
						component: CertDetail,
						meta: {
							title: '证书详情',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/contract',
						component: Contract,
						meta: {
							title: '合同管理',
							isAdmin: true
						}
					},
					{
						path: '/admin/activity/report',
						component: Report,
						meta: {
							title: '活动数据报告',
							isAdmin: true
						}
					}
				]
			}
		]
	},
	{
		path: '/login',
		component: Login,
		meta: {
			title: '登录',
			isAdmin: true
		}
	}
]
const router = new VueRouter({
	routes: routes,
	mode:'history'
})
router.beforeEach((to,from,next)=>{
    if(to.meta.title){
		document.title = to.meta.title
	}
	//判断当前进入的路由界面是否需要登录,不需要登录直接进入
	if (to.matched.some(rec => rec.meta.isLogin)) {
		//需要登录，而且需要判断是否已经登录
		if(localStorage.getItem('companyId')){
			next()
		} else{
			next('/login')
		}
	} else{
		next()
	}
})
export default router
